const configs = {
  development: { // 개발 설정
    mykeepin: {
      serviceId: 'f7c5b186-41b9-11ea-ab1a-0a0f3ad235f2',
      api: {
        authRequest: 'https://testauth.metadium.com/didauth/v1/authorize/view',
      },
      authType: {
        function1: 11,
        function2: 22,
        function3: 22,
        function4: 11,
      },
      redirectUri: {
        function1: 'https://testssp.metadium.com/function1/result',
        function2: 'https://testssp.metadium.com/function2/result',
        function3: 'https://testssp.metadium.com/function3/result',
        function4: 'https://testssp.metadium.com/function4/popup',
      },
    },
    server: 'https://testssp.metadium.com',
    desktopMinWidth: "768px",
  },
  production: { // 운영 설정
    mykeepin: {
      serviceId: 'f7c5b186-41b9-11ea-ab1a-0a0f3ad235f2', // Mykeepin 서비스 아이디
      api: { // 인증 요청 API
        authRequest: 'https://auth.mykeepin.com/didauth/v1/authorize/view',
      },
      authType: { // 인증 타입
        function1: 2,
        function2: 3,
        function3: 3,
        function4: 2,
      },
      redirectUri: { // 인증 완료후 리다이렉트될 URI
        function1: 'https://testssp.mykeepin.com/function1/result',
        function2: 'https://testssp.mykeepin.com/function2/result',
        function3: 'https://testssp.mykeepin.com/function3/result',
        function4: 'https://testssp.mykeepin.com/function4/popup',
      },
    },
    server: 'https://testssp.mykeepin.com', // 서버 도메인
    desktopMinWidth: "768px", // 모니터 너비 ... mykeepin 설정과 관련 없음
  },
};

let env = process.env.REACT_APP_NODE_ENV;
if (env !== 'development' && env !== 'test' && env !== 'production') {
  env = 'development';
}

// Select configuration based on NODE_ENV
const config = configs[env];

// Print configuration
const { log } = console;
if (env === 'development') {
  log(JSON.stringify(config, null, 4));
}

export default config;
